// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__SZISZ","button":"css_button__r-vSb","disabled":"css_disabled__5CSLd"};